export const URL_CONFIG = {
  BILL_URL: process.env.VUE_APP_BILL_URL,
  BILL_WEBSERVER_URL: process.env.VUE_APP_BILL_WEBSERVER_URL,
  USER_URL: process.env.VUE_APP_USER_URL,
  USER_WEBSERVER_URL: process.env.VUE_APP_USER_WEBSERVER_URL,
  TSIGN_URL: process.env.VUE_APP_TSIGN_URL,
  DING_URL: process.env.VUE_APP_DING_URL,
}

export default {
  // 微信支付
  weixinPay(payOrderId) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/tenpay/${payOrderId}/wap_pay`,
    }
  },
  logisticsRoutes() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/logistics/routes`,
    }
  },
  getTokenFromKey() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.TSIGN_URL}/saas-webserver/v2/oauth2/parseKey`,
    }
  },
  getKeyFromToken() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.TSIGN_URL}/saas-webserver/v2/oauth2/authKey`,
    }
  },

  /**
   * 接口配置
   */
  // 转售子订单充值式子产品单价列表查询
  getSubChilds(orderId) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/orders/${orderId}/sub/childs`,
    }
  },
  subOpenChilds(orderId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/sys_accountId/orders/${orderId}/sub/openchilds`,
    }
  },

  // 客户确认解约函解约函
  accountAffirmRescindContract() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/accountAffirmRescindContract`,
    }
  },

  // 查看是否有解约函
  hasRescindContract() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/hasRescindContract`,
    }
  },

  // 查看是否有解约函
  viewRescindContractFile() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/viewRescindContractFile`,
    }
  },

  // 查看结算单详情
  viewContractBillFile() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/viewContractBillFile`,
    }
  },

  // 查看是否有结算单
  hasContractBillFile() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/hasContractBillFile`,
    }
  },

  // 确认结算单
  accountAffirmTerminationContract() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/accountAffirmTerminationContract`,
    }
  },

  valitSys() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderResell/{gid}/orderResellCheck`,
    }
  },
  addRemark(cakeOrderId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderResell/${cakeOrderId}/addRemark`,
    }
  },
  queryZSOrder() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderResell/{gid}/queryZSOrder`,
    }
  },
  orderResellAdd() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderResell/sys_accountId/{gid}/{oid}/orderResellAdd`,
    }
  },

  // 转售方所有生效/待生效订单有效期查询
  orderResellEffectiveDate(selledGid) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderResell/${selledGid}/effectiveDate`,
    }
  },
  orderResellRecord() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderResell/{gid}/record`,
    }
  },
  getDingOrg(dingCorpId) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.DING_URL}/ding-webserver/v1/ding/corps/${dingCorpId}/users/subCorps`,
      headers: {
        'X-Tsign-Isv-App-Id': localStorage.getItem('dq_dingAppId') || localStorage.getItem('appId') || '',
      },
    }
  },
  invoicesSimpleinfo(invoiceId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/invoices/simpleinfo/${invoiceId}`,
    }
  },
  orderAuthList() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderAuth/{gid}/orderAuthList`,
    }
  },
  sendCodeAuth() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderAuth/person/sendCodeAuth`,
    }
  },
  canAuth() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderAuth/{gid}/canAuth`,
    }
  },
  orderAuthQuery() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderAuth/{gid}/orderAuthQuery`,
    }
  },
  execRule() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/orders/execRule`,
    }
  },
  getPromo() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/orders/execRule/promo`,
    }
  },
  inviteeData(inviteId) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/invites/${inviteId}/invitees/sys_accountId/inviteeData`,
    }
  },
  elecInvoicedetail(orderId, oid) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/invoices/elecInvoicedetail/${orderId}`,
      headers: {
        'X-Tsign-Open-Tenant-Id': oid,
      },
    }
  },
  getHistoryUsed() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/orders/getHistoryUsed`,
    }
  },
  orderAuthRuleCheck() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderAuth/{gid}/orderAuthRuleCheck`,
    }
  },
  orderAuthAdd() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderAuth/sys_accountId/{gid}/{oid}/orderAuthAdd`,
    }
  },
  checkAuthAmount() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderAuth/sys_accountId/{gid}/{oid}/checkAuthParams`,
    }
  },
  orderAuthDel(authId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderAuth/${authId}/orderAuthCancel`,
    }
  },

  // 充值式子产品单价列表查询
  getOrderChilds(orderId) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/orders/${orderId}/childs`,
    }
  },
  openChilds(orderId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/orders/${orderId}/openchilds`,
    }
  },
  getByCode() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/getRealAccountByCode`,
    }
  },
  getInfo() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/sys_accountId/getDecorationAllInfos`,
    }
  },
  getOrg() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/sys_accountId/organizations/org-roles`,
    }
  },
  logout() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.USER_URL}/accounts/logout`,
    }
  },
  space(orgId) {
    return {
      method: 'PUT',
      url: `${URL_CONFIG.USER_WEBSERVER_URL}/space?orgId=${orgId}`,
    }
  },
  privileges() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/sys_accountId/privileges`,
    }
  },
  volumes: orderId => ({
    method: 'GET',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orders/${orderId}/volumes`,
  }),
  exportStatus: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/billings/consume/export/detail`,
  }),

  recordExportPerson: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/person/billings/consume/export`,
  }),

  recordExportOrganize: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/organize/billings/consume/export`,
  }),

  getPersonExportType: () => ({
    method: 'GET',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/consume/person/export/type`,
  }),

  getOrganizeExportType: () => ({
    method: 'GET',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/consume/organize/export/type`,
  }),

  recordExport: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/billings/consume/export`,
  }),
  exportHistoryList: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/billings/consume/export/pageList`,
  }),
  getExpressAddress: () => ({
    method: 'GET',
    url: `${URL_CONFIG.USER_WEBSERVER_URL}/accounts/addresses`,
  }),
  getAddress: () => ({
    method: 'GET',
    url: `${URL_CONFIG.USER_WEBSERVER_URL}/addresses/areas`,
  }),
  addAddress: () => ({
    method: 'POST',
    url: `${URL_CONFIG.USER_WEBSERVER_URL}/accounts/addresses`,
  }),
  getStaticProtocol: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/viewStaticProtocol`,
  }),
  getProtocol: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/viewCart`,
  }),
  getOrderdetail: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/payorders/{gid}/orderdetail`,
  }),
  abendPayment: payOrderId => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/payments/${payOrderId}/abendPayment`,
  }),

  // 小程序支付
  appletPay: payOrderId => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/payments/${payOrderId}/applet_pay`,
  }),

  // JSAPI支付
  wechatPay: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/wechat/sign`,
  }),

  // 获取扫码支付URL
  precreatePay: payOrderId => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/payments/${payOrderId}/precreate_pay`,
  }),

  // 创建专属汇款账号
  createbankAccountNoPay: orderId => ({
    method: 'POST',
    url: `${URL_CONFIG.TSIGN_URL}/webserver/v2/exclusive/account/${orderId}/create`,
  }),

  // 专属账号确认支付
  bankpay: orderId => ({
    method: 'POST',
    url: `${URL_CONFIG.TSIGN_URL}/webserver/v2/exclusive/account/sys_guid/pay`,
  }),

  // 下载专属账号电子证明
  downloadBankCert: orderId => ({
    method: 'POST',
    url: `${URL_CONFIG.TSIGN_URL}/webserver/v2/exclusive/account/download`,
  }),

  // 轮询下载专属账号电子证明
  getDownloadBankCertUrl: oid => ({
    method: 'POST',
    url: `${URL_CONFIG.TSIGN_URL}/webserver/v2/exclusive/account/download/query`,
    headers: {
      'X-Tsign-Open-Tenant-Id': oid,
    },
  }),
  getCommodity: commodityId => ({
    method: 'GET',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/commoditys/${commodityId}`,
  }),
  getCommodities: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/commodities`,
  }),
  getPackages: productId => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/saas-common/bills/commodity/packages`,
  }),
  getTying: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/saleInfo/tying`,
  }),
  getShowCaseCommodity: caseId => ({
    method: 'GET',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/showcases/${caseId}/commodities`,
  }),
  getMenuInfo: arg => ({
    method: 'GET',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/commoditys/${arg.commodityId}/billingRules/${arg.ruleId}`,
  }),
  getOrderList() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/sys_accountId/sys_org_id/auth/orders`,
    }
  },
  getPersonOrderList() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/person/sys_accountId/sys_org_id/auth/orders`,
    }
  },
  getOrganizeOrderList() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/organize/sys_accountId/sys_org_id/auth/orders`,
    }
  },
  licenseDownload(orderId) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/orders/${orderId}/license/download`,
    }
  },
  getAuthorizedOrderList() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/sys_accountId/sys_org_id/auth/authorizedOrder`,
    }
  },
  getBillIds: () => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/sys_guid/sys_accountId/commitCart/sys_org_id`,
  }),
  getHT: orderId => ({
    method: 'POST',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/sys_accountId/order/${orderId}/sys_org_id`,
  }),

  orgGetInfo: () => ({
    method: 'GET',
    url: `${URL_CONFIG.BILL_WEBSERVER_URL}/organizations/sys_org_id/getInfo`,
  }),
  getPayOrderDetail(payOrderId) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/payments/${payOrderId}`,
    }
  },
  preCheck() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderResell/sys_accountId/{gid}/{oid}/orderResellAdd/preCheck`,
    }
  },
  getOrderDetail(arg, oid) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orders/${arg.id}?orderType=${arg.type}`,
      headers: {
        'X-Tsign-Open-Tenant-Id': oid,
      },
    }
  },
  getCommoditysList() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/commoditys`,
    }
  },
  getProductList() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.TSIGN_URL}/webserver/v2/accounts/{gid}/authed/productList`,
    }
  },
  getproductList() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/products`,
    }
  },
  getAuthList() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderAuth/user/followList`,
    }
  },
  setInvoice() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/invoices/{gid}/invoicelater/sys_guid`,
    }
  },
  recordReport() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/billings/report`,
    }
  },

  // 邀请支付订单列表
  getPayInvitations(invitationId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/payInvitations/${invitationId}`,
    }
  },

  // 获取转账信息
  getTransferInfo(invitationId) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/${invitationId}/transferInfo`,
    }
  },

  // 选择线下支付
  payByTransfer(invitationId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/payInvitations/${invitationId}/payByTransfer`,
    }
  },

  // 订单上线接口
  effectiveOrder() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/sys_guid/effectiveOrder`,
    }
  },

  // 已经打开过邀约支付链接
  getMarkOpened(invitationId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/payInvitations/${invitationId}/markOpened`,
    }
  },

  // 查看合同文件接口
  viewContractFile(contractId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/${contractId}/viewContractFile`,
    }
  },

  // 发起三方支付
  payInvitationspagePay(invitationId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/payInvitations/${invitationId}/page_pay`,
    }
  },

  recordDetail() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/billings`,
    }
  },
  queryExportContextByProductId(productId) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/consume/export/context/config/${productId}`,
    }
  },
  platformInfo() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/appinfos`,
    }
  },
  recordCount() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/billings/pageInfo`,
    }
  },

  getAvailableList() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/orders/getConsumed`,
    }
  },
  getOrgUrl(orgId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.USER_URL}/organizations/${orgId}/realname`,
    }
  }, // 企业组织实名地址
  getPersonUrl() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.USER_WEBSERVER_URL}/accounts/realname`,
    }
  }, // 个人实名地址
  getUserAccountList() {
    // 账户明细批量分页条件查询
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/statements`,
    }
  },
  getAccountWalletAmount() {
    // 通过GUID查询钱包
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/multi/wallets`,
    }
  },
  getSummaryByOrgId(orgId) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.TSIGN_URL}/webserver/v3/organizations/${orgId}/summary`,
    }
  },
  rechargeOnline() {
    // 线上充值
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/pay/{gid}/topUpOrder`,
    }
  },
  thirdPartPay(type, payOrderId) {
    // 第三方支付
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/pay/${type}/${payOrderId}`,
    }
  },

  // 使用钱包支付
  walletPay(payOrderId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/sys_accountId/payments/${payOrderId}/payByWallet`,
    }
  },

  // 根据payOrderId, 查询账单
  getBill(payOrderId) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/payments/${payOrderId}`,
    }
  },

  // 通过orderId查询订单详情
  getOrderDetailByOrderId(orderId, oid) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orders/${orderId}`,
      headers: {
        'X-Tsign-Open-Tenant-Id': oid,
      },
    }
  },

  // 提交支付
  getPayorderId() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/payorders/{gid}/createPay`,
    }
  },

  // 查询订单快递费
  getExpressFee(orderId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/invoices/fee/${orderId}`,
    }
  },

  // 获取当前用户管理员绑定的手机号
  getBindPhone() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/{oid}/mobile-phone`,
    }
  },

  // 获取手机号验证码
  getMsgCode() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/sys_guid/sys_accountId/send-mobile-code`,
    }
  },

  // 申请提现
  doApplyCash() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/sys_accountId/withdrawal-applications`,
    }
  },

  // 获取可提现金额和提现中金额
  getMoneyOfWallet() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/multi/wallets`,
    }
  },

  // 获取提现银行信息
  getMyBankInfo(needEncryption) {
    return {
      method: needEncryption ? 'POST' : 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/{oid}/last-withdrawal${needEncryption ? '/desensitize' : ''}`,
    }
  },

  // 获取枚举值
  getAccountEnums() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/account-enums`,
    }
  },

  // 获取当天是否可提现
  getIsTodayApply() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/{oid}/authenticate-withdrawal-applications`,
    }
  },

  // 根据支行名称获取银行信息
  getBankInfoBySubName() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/{oid}/billingcenter-banks`,
    }
  },

  // 标记提现失败提示
  markFailedTip(applicationId) {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/{oid}/withdrawal-applications/${applicationId}/readed-mark`,
    }
  },

  // 合并开票
  invoiceCombine() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/invoices/{gid}/invoiceCombine/sys_guid`,
    }
  },

  // 获取发票类型
  getInvoiceType() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/invoice/config`,
    }
  },

  // 获取开票结果
  queryInvoiceCombine(oid) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/invoices/{gid}/invoiceCombine`,
      headers: {
        'X-Tsign-Open-Tenant-Id': oid,
      },
    }
  },

  // 查询订单是否改价中
  checkPriceAdjusting(code) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/volume/change/price/check/${code}`,
    }
  },

  // 查询发货记录
  getDeliveryList() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/delivery/list`,
    }
  },

  // 查询导出状态
  exportDeliveryStatus() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/delivery/export/status`,
    }
  },

  // 执行导出任务
  deliveryExport() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/delivery/export`,
    }
  },

  // 发货数量
  deliveryCount() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/delivery/quantity`,
    }
  },

  // 获取微信用户openId

  getOpenId() {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/thirdplatform/wechat/official/user-info`,
    }
  },

  // 获取实际使用方列表
  getAuthedList() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderAuth/person/getAuthGidConsumed`,
    }
  },

  // 获取实际使用方列表-企业
  getAuthedListByOrg() {
    return {
      method: 'POST',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/orderAuth/organize/getAuthGidConsumed`,
    }
  },

  // 查询商品的搭售商品售卖方案对应的搭售活动
  getTyingSceneSaleInfo(oid, client) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/accounts/{gid}/tyingScene/saleInfo`,
      headers: {
        'X-Tsign-Open-Tenant-Id': oid,
        'x-tsign-client-id': client,
      },
    }
  },

  // 查询搭售主订单下的搭售子订单接口
  getTyingRecordOrders(oid) {
    return {
      method: 'GET',
      url: `${URL_CONFIG.BILL_WEBSERVER_URL}/tyingRecord/orders`,
      headers: {
        'X-Tsign-Open-Tenant-Id': oid,
      },
    }
  },
}
